import BaoCaoTongHop from './BaoCaoTongHop.jsx';

export default BaoCaoTongHop;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/index.js